<main class="app-shell">
	<section
		*ngIf="!surfaceLoadFailed"
		class="page-app-prompt"
		aria-label="Request expanded App Launcher access"
	>
		<div>
			<strong>Need more than the Labs preview?</strong>
			<span
				>The free preview includes one active deployment. Tell the App
				Launcher team what you need and request expanded access.</span
			>
		</div>
		<button
			class="primary-button"
			type="button"
			(click)="requestAccess()"
		>
			Request access
		</button>
	</section>

	<section class="apps-home">
		<div #host class="app-launcher-host"></div>
	</section>
</main>

<sd-limit-modal *ngIf="state.limitVisible"></sd-limit-modal>
